<template>
   <div style="
        width: 100%;
        height: 40px;
        text-align: right;
        padding-top: 10px;
        position: fixed;
        right: 40px;
      ">
      <el-button @click="submit"
                 type="success"
                 round>退出</el-button>
    </div>
    <div ref="mount" style="height: 100%;background-color: #FFFFFF; z-index: -1;">
       
    </div>
     <!-- <div class="loader">
          <p>正在加载中。。。</p>
        </div> -->
    <div class="haorooms_container">
        <!-- <div v-if="isLoading" class="loader">
          <p>正在加载中。。。</p>
        </div> -->
        <div id="content">
          <ul class="imagelist">
            <li v-for="item in bigImgList" :key="item.id" 
            :label="item.id" :value="item.id">
            <img  class='meun_img' :src="item.name"  @click="infos(bigImgLists.filter(c=>c.id == item.id)[0])"></li>
          </ul>
        </div>
    </div>
  </template>
  
  <script>
  import * as THREE from 'three';
  import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
//import { ElLoading } from "element-plus";
let controls=null;
let renderer= null;
let scene=null;
let camera =null;
  export default {
    name: 'ThreeScene',
    data()
    {
        return {
            anchorPoint: require("../images/panorama/icon_cell.gif"), // 图片路径
            bigImgList :[
            {
                id : 1,
                name :  require("../images/panorama/1_鸟瞰哈尔滨国际会展中心2(1).jpg"),
            },
            {
                id : 2,
                name :   require("../images/panorama/2_鸟瞰A馆国际及港澳台馆1(1).jpg"),
            },
            {
                id : 3,
                name :    require("../images/panorama/3_香港1(1).jpg"),
            },
            {
                id : 4,
                name :   require("../images/panorama/4_台湾1(1).jpg"),
            },
            {
                id : 5,
                name :   require("../images/panorama/5_澳门1(1).jpg"),
            }],
          bigImgLists :[
            {
                id : 1,
                name :  require("../images/panorama/1_鸟瞰哈尔滨国际会展中心2.jpg"),
            },
            {
                id : 2,
                name :   require("../images/panorama/2_鸟瞰A馆国际及港澳台馆1.jpg"),
            },
            {
                id : 3,
                name :    require("../images/panorama/3_香港1.jpg"),
            },
            {
                id : 4,
                name :   require("../images/panorama/4_台湾1.jpg"),
            },
            {
                id : 5,
                name :   require("../images/panorama/5_澳门1.jpg"),
            }],
            animationFrameId: null,
            isLoading:false,
            ids : 0,
            spriteMaterial:null,
            anchorIdMap:[],
            textureCache: {},
            spheres :null,
            orbitControl:[],
            width:null,
            height:null,
        }
    },
    mounted() {
      this.GetSetpHistory()
      this.infos(this.bigImgLists[0]);
    },
    beforeUnmount() {
    // 销毁内存中的threejs
      //this.destroyThreejs();
    },

    methods: {
      GetSetpHistory () {
      this.$http.get(`StudentData/GetSetpHistory?groupId=${this.$route.query.id}`).then((res) => {
        if (res.success) {
          console.log(res.success)
        }
      })
    },
// 销毁threejs
destroyThreejs() {
      try {
        cancelAnimationFrame(this.animationFrameId); // animationFrameId = requestAnimationFrame(this.render);
        renderer.dispose();
        renderer.forceContextLoss();
        renderer.content = null;
        let gl = renderer.domElement.getContext("webgl");
        if (gl && gl.getExtension("WEBGL_lose_context")) {
          gl.getExtension("WEBGL_lose_context").loseContext();
        }
        renderer = null;
        camera = null;
        scene.traverse((child) => {
          if (child.material) {
            child.material.dispose();
          }
          if (child.geometry) {
            child.geometry.dispose();
          }
          child = null;
        });
        scene = null;
      } catch (e) {
        console.error('Failed to destroy threejs', e);
      }
    },
      infos(item)
      {
        // let loading = ElLoading.service({
        //   lock: true,
        //   text: "已提交正在运算，请等待(｀・ω・')",
        //   // background: "rgba(0, 0, 0, 0.7)",
        // });
        this.isLoading=true;
        if(renderer)
        {
          var canvas = this.$refs.mount.querySelector('canvas');
          if(canvas){
            this.$refs.mount.removeChild(renderer.domElement);
            this.destroyThreejs();
          }
        }
        this.width = this.$refs.mount.clientWidth;
        this.height = this.$refs.mount.clientHeight;
                // 创建相机
        camera = new THREE.PerspectiveCamera(75, this.width / this.height, 1, 1000);
        camera.position.z = 5;
        // 创建渲染器
        renderer = new THREE.WebGLRenderer({ antialias: true });
        renderer.setSize(this.width, this.height);
        this.$refs.mount.appendChild(renderer.domElement);

        // 创建场景
        scene = new THREE.Scene();
       // 创建控制器以自由旋转视角
       controls = new OrbitControls(camera,renderer.domElement);
        controls.autoRotate = true; // 开启自动旋转
        controls.autoRotateSpeed = 1; // 设置自动旋转的速度
        controls.rotateSpeed = 0.5; // 设置拖动的速度
      // 禁止滚动和放大/缩小
        controls.enableZoom = false;
        controls.enablePan = false;
      // 监听start事件
        controls.addEventListener('start', () => {
        // 用户开始交互，停止自动旋转
          controls.autoRotate = false;
      });

        //let frame = 0;  // 初始化帧计数器
        // 创建一个全景贴图
        let loader = new THREE.TextureLoader();
        //loader.load(item);

        if (this.textureCache[item.name]) {
              let texture = this.textureCache[item.name];
                    if(this.spheres)
                    {
                      this.spheres.material.dispose();  // Dispose of material
                      this.spheres.geometry.dispose();  // Dispose of geometry
                      scene.remove(this.spheres);
                      this.spheres = null;  // Remove reference to object
                    }
                    this.isLoading=false
                    let sphereGeometry = new THREE.SphereGeometry(500, 60, 40);
                    sphereGeometry.scale(-1, 1, 1); // 翻转几何体的面，使得纹理在内部
                    let sphereMaterial = new THREE.MeshBasicMaterial({ map: texture });
                    let sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
                    this.spheres= sphere;
                   scene.add(sphere);
              
                   this.animate();

            } else {
              loader.load(
                item.name,
                (texture) => {
                    this.textureCache[item.name] = texture;
                    if(this.spheres)
                    {
                      //loading.load();
                      this.spheres.material.dispose();  // Dispose of material
                      this.spheres.geometry.dispose();  // Dispose of geometry
                      scene.remove(this.spheres);
                      this.spheres = null;  // Remove reference to object
                    }
                    this.isLoading=false
                    let sphereGeometry = new THREE.SphereGeometry(500, 60, 40);
                    sphereGeometry.scale(-1, 1, 1); // 翻转几何体的面，使得纹理在内部
                    let sphereMaterial = new THREE.MeshBasicMaterial({ map: texture });
                    let sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
                    this.spheres= sphere;
                     scene.add(sphere);
                    this.animate();
                   
                }
                );
            }
      },
      animate()
      {
        this.animationFrameId = requestAnimationFrame(this.animate);
        // 如果需要重新渲染，清除之前的渲染内存
        //this.clearMemory();
          renderer.render(scene,camera);
          controls.update();
      },
      submit () {
        if(renderer)
        {
          var canvas = this.$refs.mount.querySelector('canvas');
          if(canvas){
            this.$refs.mount.removeChild(renderer.domElement);
            this.destroyThreejs();
            
          }
        }
        this.$router.push({ path: 'selectiveexperiment' })
      },
    }
  };
  </script>
  
  <style scoped>


      .imagelist li {
          margin: 0.5rem;
          padding: 0;
      }
      .meun_img {
          width: 100px;
          height: 80px;
      }
				
			.imagelist {
				list-style: none;
				margin: 0;
				padding: 0;
				display: flex;
				position: absolute;
				bottom: 3rem;
			}
      .loader {
        position: fixed; /* 相对于视口定位 */
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%); /* 居中显示 */
        background-color: rgba(0, 0, 0, 0.7); /* 半透明黑色背景 */
        color: white;
        padding: 16px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
  </style>
  